// XSS Protection utility
export const sanitizeString = (str, maxLength = 1000) => {
    if (typeof str !== 'string') return '';
    
    return str
        .trim()
        .replace(/[<>"&]/g, '') // Remove potentially dangerous characters (apostrophes allowed)
        .slice(0, maxLength); // Limit length
};

export const sanitizeNumber = (num, min = 0, max = 999999999) => {
    const parsed = Number(num);
    if (isNaN(parsed)) return 0;
    return Math.max(min, Math.min(parsed, max));
};

export const sanitizeEmail = (email) => {
    if (typeof email !== 'string') return '';
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const sanitized = sanitizeString(email, 254); // RFC standard max length
    
    return emailRegex.test(sanitized) ? sanitized : '';
};

// Validate date inputs
export const sanitizeDate = (dateStr) => {
    if (!dateStr) return null;
    
    // Handle Firestore Timestamp objects
    let date;
    if (typeof dateStr === 'object' && typeof dateStr.toDate === 'function') {
        date = dateStr.toDate();
    } else {
        date = new Date(dateStr);
    }
    
    const now = new Date();
    const hundredYearsAgo = new Date(now.getFullYear() - 100, 0, 1);
    const hundredYearsFromNow = new Date(now.getFullYear() + 100, 0, 1);
    
    if (isNaN(date.getTime()) || date < hundredYearsAgo || date > hundredYearsFromNow) {
        return null;
    }
    
    return date.toISOString();
};

/**
 * Generic entity sanitizer.
 * @param {Object} obj - The object to sanitize.
 * @param {Object} schema - { fieldName: sanitizerFunction }
 * @returns {Object} - Sanitized object.
 */
export const sanitizeEntity = (obj, schema) => {
    const result = {};
    for (const key in schema) {
        result[key] = schema[key](obj[key]);
    }
    return result;
};

export const sanitizeSchema = {
    id: val => sanitizeString(val, 100),
    stage: val => sanitizeString(val, 50),
    value: val => sanitizeNumber(val, 0, 999999999),
    customerId: val => sanitizeString(val, 100),
    startDate: sanitizeDate,
    date: sanitizeDate,
    dueDate: sanitizeDate,
    closedDate: sanitizeDate,
    // ...add more fields as needed
};


